import { queryClient } from '@/client/utils/query-client';

// SDK hooks build keys as [queryKey(option, usually undefined), 'Name', params],
// so the name sits at index 1, not 0 — match by inclusion. The old [0] ===
// comparison silently matched NOTHING: every reset/refetch here was a no-op
// (logout never cleared the previous user's cached identity).
export const refetchQuery = async (fastKey: string) => {
  return await queryClient.refetchQueries({ predicate: query => query.queryKey.includes(fastKey) });
};

export const resetQuery = (fastKey: string) => {
  return queryClient.resetQueries({ predicate: query => query.queryKey.includes(fastKey) });
};

export const refetchUserLogin = async () => await refetchQuery('UserLogin');
export const resetUserLogin = () => resetQuery('UserLogin');

export const resetMe = () => resetQuery('Me');

export const refetchSignedUserAssets = async () => await refetchQuery('SignedUserAssets');
export const resetQuerySignedUserAssets = () => resetQuery('SignedUserAssets');

export const refetchSignedUserInfo = async () => await refetchQuery('SignedUserInfo');
export const resetQuerySignedUserInfo = () => resetQuery('SignedUserInfo');

export const getMarketTags = () => queryClient.getQueryData(['MarketTags', 1, 20]) as string[];

export const refetchUserPositions = async () => await refetchQuery('UserPositions');
export const refetchSignedFollowMarkets = async () => await refetchQuery('SignedFollowMarkets');

export const refetchMarketPosts = async () => await refetchQuery('MarketPosts');
export const refetchComments = async () => await refetchQuery('Comments');

export const refetchSignedNotifications = async () => await refetchQuery('SignedNotifications');
